import { ButtonPaginacion } from "./ButtonPaginacion";
export const ShowButtonsPaginacion = ({
  paginaInicial,
  paginaFinal,
  paginaActual,
  setPaginaActual,
  paginas,
}) => {
  return (
    <>
      <ul className="flex gap-1 justify-center items-center flex-wrap">
        {paginaInicial > 1 && (
          <ButtonPaginacion
            paginaActual={paginaActual}
            setPaginaActual={setPaginaActual}
            icon={"<<"}
            sign={"-"}
          />
        )}

        {Array.from({ length: paginaFinal - paginaInicial + 1 }).map(
          (_, index) => {
            const page = paginaInicial + index;
            return (
              <li key={index}>
                <button
                  className={`text-black rounded-full  font-semibold p-3  shadow-xl transition-all duration-700 ${page === paginaActual
                      ? "bg-yellow-500 text-white"
                      : "border border-slate-200 bg-white hover:border-yellow-500 hover:scale-95 "
                    }`}
                  onClick={() => setPaginaActual(page)}
                >
                  {page}
                </button>
              </li>
            );
          }
        )}

        {paginaFinal < paginas.length && (
          <ButtonPaginacion
            paginaActual={paginaActual}
            setPaginaActual={setPaginaActual}
            icon={">>"}
            sign={"+"}
          />
        )}
      </ul>
      <span className="flex justify-center items-center gap-1">
        <span className="text-blue-700">{paginaActual}</span>
        <p className="text-sm">de</p>
        <span className="text-blue-700">{paginas.length}</span>
      </span>
    </>
  );
};
